var createHtmlRenderState = function createHtmlRenderState() {
  return {
    style: {},
    transform: {},
    transformOrigin: {},
    vars: {}
  };
};
export { createHtmlRenderState };